import { render } from "./DriverPortal.vue?vue&type=template&id=b6507a04&scoped=true"
import script from "./DriverPortal.vue?vue&type=script&lang=js"
export * from "./DriverPortal.vue?vue&type=script&lang=js"

import "./DriverPortal.vue?vue&type=style&index=0&id=b6507a04&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6507a04"]])

export default __exports__